<template>
  <v-container v-if="news">
    <div style="position:relative;overflow: hidden;display:inline-block;margin:auto;">
      <div data-aos-anchor=".title-border" class="d-flex title-border border-white" data-aos="custom-fade" data-aos-duration="2000" style='min-width:100%;padding:1px;'></div>
      <div :class="$i18n.locale=='en'?'georgia font-size-XXL':'NotoSerifTC font-size-XXL-chi'" class="bordertitle" style="opacity: 0;cursor:default" v-html="$t('affiliate_news_page.title', { affiliate_name: news.name[$i18n.locale] })"></div>
      <div :class="$i18n.locale=='en'?'georgia font-size-XXL':'NotoSerifTC font-size-XXL-chi'" class="bordertitle" data-aos-easing="ease-out" data-aos="custom-title-fade-in" data-aos-duration="1000" data-aos-delay="500" v-html="$t('affiliate_news_page.title', { affiliate_name: news.name[$i18n.locale] })"></div>
      <div data-aos-anchor=".title-border" class="d-flex title-border border-white" data-aos="custom-fade" data-aos-duration="2000" style='min-width:100%;padding:1px;'></div>
    </div>
    <v-row style="margin-top:45px;" v-if="!$vuetify.breakpoint.xs" >
      <v-col class="pa-3" sm="6" md="4" lg="4" xl="4" v-for="(an, i) in news.News.slice((page-1)*12, page*12)" :key="an.id" data-aos="fade-up" data-aos-duration="3000">
        <div class="news-card">
          <v-img
            :src="ip+an.contents[0].formats.small.url"
            alt="John"
            height="55.8%"
            width="100%"
            class="news-card-image"
          >
          </v-img>
          <div :class="$i18n.locale=='en'?'DinCond':'MHeiHK'"  class="news-card-desc">
            <div class="contentl font-size-s6">{{an.title[$i18n.locale]}}</div>
            <div class="contents font-size-s6">{{$t('affiliate_news_page.featured_on')}} <span class="special-text">{{an.featured_on}}</span></div>
            <div class="contents font-size-s6"><span class="special-text">{{an.featured_date}}</span></div>
            <div class="button font-size-s7" style="margin-top:3%" @click="openDialog(an, i)">
                <span :class="$i18n.locale=='en'?'DinCond':'NotoSerifTC'">{{$t('affiliate_news_page.read_more')}}</span>
                <simple-line-icons
                  icon="arrow-right"
                  size="large"
                  style="padding-left:10px"
                  no-svg
                />
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <div style="margin-top:15px;" v-if="$vuetify.breakpoint.xs" >
      <div style="margin-top:14px;position:relative;width: 100%;padding-top:37%;" v-for="(an, i) in news.News.slice((page-1)*12, page*12)" :key="an.id" data-aos="fade-up" data-aos-duration="3000">
        <div style="position:absolute;top:0;left:0;width: 100%;height:100%;padding: 4px">
          <v-img
            :src="ip+an.contents[0].formats.small.url"
            alt="John"
            height="100%"
            width="46%"
            style="float:left;margin-right:2%;"
          />
          <div :class="$i18n.locale=='en'?'DinCond':'MHeiHK'" style="padding:5px 10px;float:left;margin-left:auto;width:52%;height:100%;border:1px mediumseagreen solid;border-left:0px mediumseagreen solid;position:relative;letter-spacing:1.5px;">
            <div class="text-start" style="line-height:1.3;color:white;">{{an.title[$i18n.locale]}}</div>
            <div class="text-start newsdate" style="position: absolute; bottom: 10px; left: 10px;color:white; line-height:1.3;">
              {{$t('affiliate_news_page.featured_on')}} <span class="special-text">{{an.featured_on}}</span>
              <br><span class="special-text">{{an.featured_date}}</span>
              <div class="button" @click="openDialog(an, i)">
                <span :class="$i18n.locale=='en'?'DinCondL':'NotoSerifTC'">{{$t('affiliate_news_page.read_more')}}</span>
                <simple-line-icons
                  icon="arrow-right"
                  style="padding-left:2px"
                  no-svg
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-row>
      <div style="margin: auto;">
        <span class="pageination" v-for="(w) in Math.ceil(news.News.length/12)" :key=w :class="w==page?'selected':null" v-on:click="page=w">{{w}}</span>
      </div>
    </v-row>
    <div class="custom-dialog" :class="dialog?'custom-dialog-show':''" >
      <div class="overlay" @click.self.stop="dialog = false;currentPhotoIndex=0;">
        <div class="main-dialog" :class="dialog?'ddd':''">
          <div style="position:absolute;top:0;bottom:0;left:0;right:0;background:black;opacity:0.9;padding:50px;"></div>
            <v-icon @click="dialog = false;currentPhotoIndex=0;" style="cursor:pointer;color:white;position:absolute;top:15px;right:15px;" size=36>mdi-close</v-icon>
            <div style="z-index:0;border-bottom:1px white solid;position:relative;">
              <v-row :class="$i18n.locale=='en'?'DinCond font-size-s7':'MHeiHK'" class="ma-0 pa-3" style="letter-spacing:2px;">
                <span style="margin-top:15px;color:white;z-index:0;">{{currentNews.title[$i18n.locale]}}</span>
                <span style="margin-top:15px;margin-left:auto;color:white;z-index:0;">{{$t('affiliate_news_page.featured_on')}} <span class="special-text">{{currentNews.featured_on}}</span></span>
                <span style="margin-top:15px;margin-left:5px;color:white;z-index:0;"><span class="special-text">{{currentNews.featured_date}}</span></span>
                <v-icon v-if="currentNews.link" style="cursor:pointer;margin-left:15px;background:white;padding:10px;border-radius: 20px;color:black;" size=20 v-on:click="goto(currentNews.link)">mdi-link-variant</v-icon>
              </v-row>
            </div>
            <v-row class="pa-0 inner-dialog">
              <v-col v-if="currentNews.contents.length>1" sm=1 md=1 lg=1 xl=1 class="d-flex justify-center align-center" style="z-index:0;cursor:pointer;" v-on:click="prev()">
                <simple-line-icons
                  icon="arrow-left"
                  color="white"
                  class="align-self-center"
                  style="font-size:60px;"
                  no-svg
                />
              </v-col>
              <v-col sm=10 md=10 lg=10 xl=10 style="z-index:0;margin: auto;" class="pa-5">
                <v-img
                  :src="ip+currentNews.contents[currentPhotoIndex].url"
                  alt="John"
                />
              </v-col>
              <v-col v-if="currentNews.contents.length>1" sm=1 md=1 lg=1 xl=1 class="d-flex justify-center align-center" style="z-index:0;cursor:pointer;" v-on:click="next()">
                <simple-line-icons
                  icon="arrow-right"
                  color="white"
                  style="font-size:60px;"
                  no-svg
                />
              </v-col>
            </v-row>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script> 
import axios from 'axios';
var ip = "https://lorencegroup.com/api";
import moment from 'moment'
export default {
  name: 'News',
  components: {
  },
  data: () => ({
    "dialog": false,
    news: null,
    currentNews: null,
    currentIndex: 0,
    currentPhotoIndex: 0,
    ip: ip,
    page: 1,
  }),
  methods: {
    openDialog(an, i){
      this.dialog = true;
      this.currentNews = an;
      this.currentIndex = i;
    },
    next: function(){
      if(this.currentPhotoIndex == this.currentNews.contents.length-1){
        this.currentPhotoIndex = 0;
      }
      else{
        this.currentPhotoIndex++
      }
    },
    prev: function(){
      if(this.currentPhotoIndex == 0){
        this.currentPhotoIndex = this.currentNews.contents.length-1
      }
      else{
        this.currentPhotoIndex--
      }
    },
    goto: function(url){
      window.open(
        url,
        '_blank' // <- This is what makes it open in a new window.
      );
    }
  },
  mounted () {
    axios.get(ip+"/affiliate-news/"+this.$router.history.current.params.affiliate_id)
    .then(response => {
      this.news=response.data;
      this.news.name=[]
      this.news.name["en"] = this.news.display_affiliate_english;
      this.news.name["zh_TW"] = this.news.display_affiliate_trad_chinese;
      this.news.News.forEach(an => {
        if(this.$i18n.locale == 'en')
          an.featured_date = moment(an.featured_date, "YYYY-MM-DD").format("DD MMM YYYY");
        else
          an.featured_date = moment(an.featured_date, "YYYY-MM-DD").format("DD/MM/YYYY");
        an.title=[]
        an.title["en"] = an.display_title_english;
        an.title["zh_TW"] = an.display_title_trad_chinese;
      });
      this.currentNews = this.news.News[0];
      console.log(this.news)
    })
    .catch(e => {
      console.log(e)
      //this.errors.push(e)
    })
  }
}
</script>
<style scoped>
.NotoSerifTC{
  transform: scaleX(.9);
}

.pageination{
  color: white;
  margin: 10px;
  cursor: pointer;
}

.selected{
  text-decoration: underline;
}

.bordertitle{
  text-transform: uppercase;
  letter-spacing: 5px;
  margin:auto;
  padding: 15px;
  margin-top:6px;
  margin-bottom:6px;
  color: white;
}
.mobile .bordertitle{
  text-transform: uppercase;
  letter-spacing: 3px;
  font-size: 20px;
  margin:auto;
  padding: 0px 3px;
  margin-top:6px;
  margin-bottom:6px;
  color: white;
}
.custom-dialog{
  overflow-y: scroll;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
}
.custom-dialog-show{
  z-index: 1;
}
.custom-dialog .overlay{
  height: 100%;
  width: 100%;
}
.custom-dialog .main-dialog{
  position: relative;
  width: 70%;
  margin: auto;
  padding: 30px 55px;
}
.custom-dialog .main-dialog span{
  color: #132b1b;
}

.custom-dialog .main-dialog .special-text{
  color: mediumseagreen;
  z-index: 0;
}
@media (min-width: 768px) { 
  .custom-dialog .main-dialog{
    width: 100%;
    top: 50px;
    max-width: 800px;
  }
  .inner-dialog{
    max-width: 800px;
    margin: auto;
  }
}
@media (min-width: 992px) { 
  .custom-dialog .main-dialog{
    width: 80%;
    top: 50px;
    max-width: 900px;
  }
  .inner-dialog{
    max-width: 800px;
    margin: auto;
  }
}
@media (min-width: 1264px) {
  .custom-dialog .main-dialog{
    width: 80%;
    top: 50px;
    max-width: 1100px;
  }
  .inner-dialog{
    max-width: 800px;
    margin: auto;
  }
}
@media (min-width: 1904px) { 
  .custom-dialog .main-dialog{
    width: 70%;
    top: 50px;
    max-width: 1300px;
  }
  .inner-dialog{
    max-width: 800px;
    margin: auto;
  }
}
.kitchen-name{
  margin:auto;
  color: white;
  font-size: 3em;
  padding: 5px;
  border-top: 1px white solid;
  border-bottom: 1px white solid;
}
.sub-title{
  margin: auto;
  color: white;
  font-size: 2em;
  border-top: 1px white solid;
  border-bottom: 1px white solid;
}
.news-card{
  position: relative;
  padding-top:120%;
}
.mobile .news-card{
  position: relative;
  padding-top:40%;
}
.news-card-image{
  position: absolute;
  top:0;
  left:0;
}
.news-card-desc{
  position: absolute;
  padding-top : 4px;
  padding-bottom: 4px;
  top:58%;
  left:0;
  height:42%;
  width: 100%;
  color: white;
  border: 1px solid green;
  border-top: 0px solid green;
}

.news-card-desc .name{
  font-size: 1.3em;
  height: 35%;
}

.news-card-desc .feature{
  font-size: .8em;
}

.news-card-desc .date{
  font-size: .8em;
}

.news-card-desc .button{
  margin: auto;
  color: green;
  border: green solid 1px;
  display: flex;
  width: fit-content;
  align-items:center;
  cursor: pointer;
}

.button .NotoSerifTC{
  transform: scale(1, 1);
}

.mobile .button{
  color: green;
  border: green solid 1px;
  display: flex;
  width: fit-content;
  align-items:center;
  cursor: pointer;
  font-size: 14px !important; 
  padding: 6px 2px 6px 10px; 
  margin: 0;
  margin-top: 3px;
  letter-spacing: 0.5px;
}

.news-card-desc .button:hover{
  background: green;
  color: white;
}

.special-text{
  color: green;
}

@media (min-width: 576px) {
  .news-card-desc .button{
    padding:5px 20px; 
  }
}

@media (min-width: 768px) {
  .news-card-desc .button{
    padding:5px 20px;
  }
}

@media (min-width: 992px) { 
  .news-card-desc .button{
    padding:4.5px 18px; 
  }
}
@media (min-width: 1264px) {
  .news-card-desc .button{
    padding:5px 20px; 
  }
}

@media (min-width: 1904px){
  .news-card-desc .button{
    padding:5px 20px; 
  }
}
</style>